<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false,
      showSkipButton: true,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    skipToContent(event) {
      event.preventDefault();
      const header = this.$el;
      const focusableElements = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const elements = document.querySelectorAll(focusableElements);
      const firstFocusableElement = Array.from(elements).find(el => !header.contains(el));

      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }

      this.showSkipButton = false;
    },
    handleSkipButtonBlur() {
      setTimeout(() => {
        if (!this.$el.contains(document.activeElement)) {
          this.showSkipButton = false;
        }
      }, 0);
    },
  },
};
</script>
<template>
  <header>
    <button
      ref="skipButton"
      v-show="showSkipButton"
      @click="skipToContent"
      @keydown.enter="skipToContent"
      @keydown.space="skipToContent"
      @blur="handleSkipButtonBlur"
      class="skip-to-content"
      aria-label="Button skip"
      tabindex="0"
    >
      Skip to Content
    </button>
    <h1>
      <div class="logo">
        <router-link :to="{ name: 'Home' }" title="Homepage"><img src="../img/logo.png" alt="Re Shaping" /></router-link>
      </div>
    </h1>
    <!-- NAV -->
    <button id="boton" aria-label="Button open" @click="toggleMenu" :class="{ open: isMenuOpen }"></button>
    <nav aria-label="Main Navigation">
    <ul class="menu" :class="{ open: isMenuOpen }">
      <li :class="['home', { active: $route.name === 'Home' }]">
        <router-link :to="{ name: 'Home' }" title="Homepage"
          onclick="location.reload(); windows.history.go();">Home</router-link>
      </li>
      <li :class="['population-identification', { active: $route.name === 'PopulationIdentificationProcesses' }]">
        <router-link :to="{ name: 'PopulationIdentificationProcesses' }"
          title="Population Identification Processes">Population Identification  Processes</router-link>
      </li>
      <li :class="['expanding-capabilities', { active: $route.name === 'ExpandingInternalAwareness' }]">
        <router-link :to="{ name: 'ExpandingInternalAwareness' }" title="Expanding Internal Awareness">Expanding
          Internal
          Awareness</router-link>
      </li>
      <li :class="['collaborative-care', { active: $route.name === 'CollaborativeCareResources' }]">
        <router-link :to="{ name: 'CollaborativeCareResources' }" title="Collaborative Care Resources">Collaborative
          Care
          Resources</router-link>
      </li>
      <li :class="['process-evaluation', { active: $route.name === 'ProcessEvaluation' }]">
        <router-link :to="{ name: 'ProcessEvaluation' }" title="Process Evaluation ReShaping">Process Evaluation</router-link>
      </li>
      <li :class="['resource-library', { active: $route.name === 'ResourceLibrary' }]">
        <router-link :to="{ name: 'ResourceLibrary' }" title="Resource Library">Resource Library</router-link>
      </li>
      <li :class="['site-guide', { active: $route.name === 'SiteGuide' }]">
        <router-link :to="{ name: 'SiteGuide' }" title="Site Guide ReShaping">Site Guide</router-link>
      </li>
    </ul>
    </nav>
    <!-- NAV -->
  </header>
</template>

<style scoped>
.skip-to-content {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 10px;
  background-color: #fff;
  color: #000;
  z-index: 1000;
  border-radius: 10px;
}

.skip-to-content:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
#app>div {
  width: 100%;
}

header {
  margin-left: 75px;
  display: flex;

}

header .logo {
  margin: 47px 0 0 0;
}

header a {
  color: #000000;
  font-family: "Gotham", sans-serif;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  text-decoration: none;
}

header ul {
  display: inline-block;
  margin: 86px 0 0 54px;
  display: flex;
}

header li {
  display: inline-block;
  margin-right: 52px;
  vertical-align: top;
}

.site-guide,
#menuToggle,
#boton,
.home {
  display: none;
}

@media screen and (max-width: 1024px) {
  header {
    margin-left: 25px;
  }

  header {
    margin-left: 25px;
  }

  header li {
    margin-right: 45px;
    width: min-content;
  }
}

@media screen and (max-width: 880px) {

  header {
    margin-left: 7%;
  }

  header ul {
    display: block;
    margin: 0;
  }

  header li {
    margin: 0;
  }

  #boton {
    height: 36px;
    position: absolute;
    cursor: pointer;
    right: 53px;
    top: 55px;
    width: 50px;
    z-index: 100000;
    border: 0;
  }

  .menu {
    background: #00a0df;
    border-radius: 0 0 0 100px;
    left: 0px;
    min-width: 100%;
    padding: 108px 58px 50px 58px;
    position: absolute;
    top: 0px;
    transition: all 0.5s;
    transform: translatex(-100%);
    z-index: 99999;
  }

  .menu li {
    border-bottom: 2px solid #ffffff;
    font-size: 24px;
    height: 146px;
    line-height: 146px;
    width: 100%;
  }

  .menu a {
    color: #ffffff;
    display: block;
    font-family: "GothamBook", sans-serif;
    font-size: 24px;
    height: 146px;
    line-height: 146px;
    padding: 0 80px 0 133px;
    white-space: nowrap;
  }

  .menu .active a {
    color: #001252;
    font-weight: bold;
  }

  .menu a br {
    display: none;
  }

  .menu {
    /* ... */
    transform: translatex(-100%);
  }

  .menu.open {
    transform: translatex(0%);
  }

  #menuToggle {
    height: 36px;
    position: absolute;
    right: 53px;
    top: 55px;
    width: 50px;
    z-index: 1;
  }

  #boton {
    /* ... */
    background: url(../img/icon-menu.png) no-repeat center center;
    background-size: cover;
  }

  #boton.open {
    background: url(../img/icon-menu-close.png) no-repeat center center;
  }

  .site-guide,
  #menuToggle,
  #boton,
  .home {
    display: block;
  }

  .home a {
    background: url(../img/icon-menu-home.png) no-repeat left center;
  }

  .population-identification {
    background: url(../img/icon-menu-glass.png) no-repeat left center;
  }

  .expanding-capabilities {
    background: url(../img/icon-menu-expanding.png) no-repeat left center;
  }

  .collaborative-care {
    background: url(../img/icon-menu-hands.png) no-repeat left center;
  }

  .process-evaluation {
    background: url(../img/icon-menu-process.png) no-repeat left center;
  }

  .resource-library {
    background: url(../img/icon-menu-resources.png) no-repeat left center;
  }

  .site-guide {
    background: url(../img/icon-menu-book.png) no-repeat left center;
  }

  .menu li.site-guide {
    border: 0;
  }

  .menu li a {
    position: relative;
  }

  .menu li a::after {
    content: '>';
    color: #0f3765;
    font-size: 29px;
    font-weight: bold;
    position: absolute;
    right: 0;
  }

  .home a {
    background-size: 38px auto;
  }

  .population-identification {
    background-size: 37px auto;
  }

  .expanding-capabilities,
  .collaborative-care {
    background-size: 35px auto;
  }

  .process-evaluation,
  .resource-library {
    background-size: 31px auto;
  }

  .site-guide {
    background-size: 33px auto;
  }

  .top-banner header .logo img {
    width: 60%;
  }


}


@media screen and (max-width: 540px) {
  .menu {
    padding: 100px 20px 50px 20px;
    width: calc(100% - 40px);
    overflow: hidden;
  }

  .menu li {
    height: 96px;
    line-height: 96px;
  }

  .menu a {
    font-size: 22px;
    height: 96px;
    line-height: 96px;
    padding: 0 20px 0 100px;
  }

}


@media screen and (max-width: 880px) {
  #boton {
    right: 13px;
    top: 20px;
  }

  header #boton {
    width: 40px;
    height: 27px;
    right: 40px;
    top: 45px;
    background-size: cover;
  }

  header #boton.open {
    width: 28px;
    height: 28px;
    right: 40px;
    top: 45px;
    background-size: cover;
  }

  .menu {
    padding-top: 60px;
    padding-left: 30px;
    padding-right: 30px;
    border-radius: 0 0 0 50px;
    height: 580px;
    width: 100%;
    box-sizing: border-box;
  }

  .menu a {
    height: 70px;
    line-height: 78px;
    padding-left: 60px;
  }

  .menu li {
    height: 70px;
    border-bottom-width: 1px;
  }

  .menu li a {
    font-weight: 400;
    line-height: 70px;
  }

  .menu li a:after {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .menu a {
    font-size: 12px;
    padding-left: 60px;
  }
}

@media screen and (max-width: 415px) {
  header {
    margin-left: 30px;
  }

  header .logo {
    margin: 23px 0 0 0;
  }

  header #boton.open {
    width: 28px;
    height: 28px;
    right: 20px;
    top: 23px;
    background-size: cover;
  }

  header #boton {
    right: 20px;
    top: 23px;
  }

  #boton {
    right: 13px;
    top: 16px;
  }

  .menu {
    padding-left: 15px;
    padding-right: 15px;
  }

  .menu a {
    padding-left: 45px;
  }

}

@media screen and (min-width: 881px) {

  header li.active {
    border-bottom: 6px solid #00a0df;
    height: 50px;
    padding-bottom: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue